<template>
  <div class="live live02">
    <div class="inner">
      <Title>
        <template #title>
          学び・体験・遊びLIVE
        </template>
      </Title>
      <div class="description">
        <p>
          全国のママ主催者による楽しい「学び・体験・遊びLIVE」<br>
          ひとりで、親子で、気軽に参加しよう♪
        </p>
      </div>
      <div class="live-programs"
        v-if="month === '202009' && $store.state.providerDataCompleted"
        >
        <template v-if="selectTime === 'すべて'">
          <template v-for="(frame, key) in [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
            <LiveProgram09
                v-for="program in getProgramAtInterval(frame)"
                :key="program.id + key"
                :program="program"
                liveType="provider"
                :month="month"
              />
          </template>
        </template>
        <template v-else>
          <LiveProgram09
            v-for="program in providerLive0915"
            :key="program.id + key"
            :program="program"
            liveType="provider"
            :month="month"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import Title from '@/components/atoms/Title.vue'
import LiveProgram09 from '@/components/molecules/202009sendai/LiveProgram.vue'

export default {
  props: {
    month: {
      type: String,
      required: true
    }
  },
  components: {
    Title,
    LiveProgram09
    // InfiniteLoading,
    // Spinner
  },
  data: () => ({
    infiniteId: +new Date(),
    providerLive: [],
    loaded: false,
    table0915: {
      1: '10:30',
      2: '11:00',
      3: '11:30',
      4: '12:00',
      5: '12:30',
      6: '13:00',
      7: '13:30',
      8: '14:00',
      9: '14:30',
      10: '15:00'
    }
  }),
  computed: {
    ...mapState([
      'dateTab',
      'lastProviderSnapshots',
      'selectTime'
    ]),
    ...mapGetters([
      'providerLive0915'
    ])
  },
  methods: {
    ...mapActions([
      'getHyblidProviderLivePrograms'
    ]),
    setLive () {
      this.providerLive = this.providerLive0915
    },
    getProgramAtInterval (frame) {
      const lives = this.providerLive0915.filter(live => live.deliveryFrame.includes(frame))
      return lives
    }
  },
  async mounted () {
    await this.getHyblidProviderLivePrograms()
  }
}
</script>

<style lang="sass" scoped>
.live02
  background-color: #fff
  padding: 25px 0
</style>
